import DataImageModel from "./dataImage";
import ImageModel from "./image";
import TileDataImageModel from "./tileDataImage";
var ImageModels = {
  image: ImageModel,
  dataImage: DataImageModel,
  tileDataImage: TileDataImageModel
};
export default ImageModels;